import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const updateSingleDeviceVncPasswordAPI = async (
  t,
  deviceId,
  oldPwd,
  pwd,
  onClose,
  setOldPasswordIncorrect,
  getDeviceDetail,
  setIsSubmitting
) => {
  try {
    await axios({
      url: `/api/v2/vnc/security/update-device`,
      method: "PUT",
      data: {
        device_id: deviceId,
        old_password: oldPwd ? oldPwd : undefined,
        password: pwd
      }
    });

    const successfulText = `${t("vnc.successfullyUpdateVncPassword")}`;
    successHandling(t, successfulText);
    getDeviceDetail();
    onClose();
    return true;
  } catch (error) {
    setOldPasswordIncorrect(true);
    setIsSubmitting(false);
  }
};
